export default __webpack_public_path__ + "static/media/radiant-bright-yellow-orange.d6172f28.jpg";